// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__34L5z","footer":"ModalCreateQualiphyProcedure_footer__2gvMe","additionData":"ModalCreateQualiphyProcedure_additionData__fTTqN"};